// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__32Hqk","notes":"Notes_notes__3Htav","note":"Notes_note__bDmTn","markdown":"Notes_markdown__1yXsC"};